<template>
  <div class="original-bill">
    <div class="header">
      <el-input class="query" v-model.trim="invoiceTitle" placeholder="请输入发票抬头" clearable @keyup.native.enter="getBillList(1)" @clear="getBillList(1)"></el-input>
      <el-button type="primary" @click="getBillList(1)">查询</el-button>
      <el-button type="primary" style="float: right;" @click="exportList">导出</el-button>
    </div>
    <Table :data="billList" :columns="columns" :pages="pages"></Table>
    <!-- 更多信息 -->
    <el-dialog title="更多信息" :visible.sync="moreInfoVisible" width="500px">
      <el-form label-width="120px" label-position="right" label-suffix="：">
        <el-form-item label="地址" prop="oldPassWd">{{ curRow.address }}</el-form-item>
        <el-form-item label="电话" prop="newPassWd">{{ curRow.phone }}</el-form-item>
        <el-form-item label="开户行" prop="newPassWdRepeat">{{ curRow.bankName }}</el-form-item>
        <el-form-item label="开户行账号" prop="newPassWdRepeat">{{ curRow.accountNumber }}</el-form-item>
      </el-form>
    </el-dialog>
    <!-- 完成开票 -->
    <el-dialog title="完成开票" :visible.sync="doneInvoiceVisible" width="500px" @close="closeDialog">
      <el-form ref="invoiceForm" label-width="100px" label-position="right" :model="formObj" :rules="rules" label-suffix="：">
        <el-form-item label="开票说明" prop="remark">
          <el-input type="textarea" v-model="formObj.remark" rows="5" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="plain" @click="doneInvoiceVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRemark">确定</el-button>
      </div>
    </el-dialog>
    <export-tip ref="exportTip" />
  </div>
</template>
<script>
import InvoiceService from "@/apis/InvoiceService";
import orderService from "@/apis/orderService";
import Table from "@/components/new-table.vue";
import { InvoiceState, OpenInvoiceTypeLabel, InvoiceStateLabel, OpenInvoiceType } from "@/service/enum";
import { Message, MessageBox } from "element-ui";
export default {
  components: { Table },
  data() {
    return {
      invoiceTitle: "",
      billList: [],
      columns: [
        { label: "申请应用", prop: "appName", "min-width": "120px" },
        { label: "订单号", prop: "orderNo", "min-width": "120px" },
        { label: "开票方式", prop: "openInvoiceTypeLabel", "min-width": "80px" },
        {
          label: "发票抬头/税号", "min-width": "120px", render: (h, { row }) => {
            return <div class="md-ellipsis">{row.invoiceTitle}<br/>{row.taxNumber}</div>
          },
        },
        {
          label: "发票金额", prop: "invoiceAmount", "min-width": "70px", render: (h, { row }) => {
            return <div> {orderService.toYuan((row.invoiceAmount * 100).toFixed(0))} </div>
          }
        },
        {
          label: "开户银行/账号", "min-width": "120px", render: (h, { row }) => {
            return <div class="md-ellipsis">{row.bankName}<br/>{row.accountNumber}</div>
          },
        },
        {
          label: "收件人/联系方式", "min-width": "130px", render: (h, { row }) => {
            return <div>
              <div>{row.receiveUserName}</div>
              <div>{row.receiveUserPhone}</div>
            </div>
          },
        },
        { label: "收件邮箱或地址", "min-width": "120px", prop: "emailOrAddress" },
        { label: "申请时间", prop: "applyTime", "min-width": "100px" },
        { label: "开票说明", prop: "invoiceRemark", "min-width": "80px" },
        { label: "状态", prop: "invoiceStateLabel", "min-width": "80px" },
        {
          label: "操作", width: "140px", render: (h, { row }) => {
            return <div>
              <el-button type="text" onClick={() => { this.showMoreInfo(row) }}>更多信息</el-button >
              <el-button type="text" onClick={() => { this.doneInvoice(row) }}>{this.getOpBtns(row)}</el-button >
            </div>
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
      moreInfoVisible: false,
      doneInvoiceVisible: false,
      formObj: {
        remark: ""
      },
      rules: {
        remark: [
          { required: true, message: "请输入开票说明", trigger: "blur" }
        ],
      },
      curRow: {},
      exportTitle: ""
    }
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    getBillList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      InvoiceService.getOrderInvoiceList(page, pageSize, this.invoiceTitle).then(res => {
        this.billList = res.data.map(item => {
          item.openInvoiceTypeLabel = OpenInvoiceTypeLabel[item.openInvoiceType];
          item.invoiceStateLabel = InvoiceStateLabel[item.invoiceState];
          const address = (item.province || "") + (item.city || "") + (item.district || "") + (item.receiveAddress || "");
          item.emailOrAddress = item.openInvoiceType === OpenInvoiceType.paper ? address : item.email;
          return item;
        });
        this.pages.props.total = res.dataCount;
        this.exportTitle = this.invoiceTitle; // 防止只输入不搜索，导致导出的表格和列表数据不同；
      });
    },
    exportList() {
      const page = this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      InvoiceService.exportOrderInvoiceList(page, pageSize, this.exportTitle);
      this.$refs.exportTip.open();
    },
    getOpBtns(row) {
      switch (row.invoiceState) {
        case InvoiceState.pending:
          return "准备开票";
        case InvoiceState.doing:
          return "开票完成";
        default:
          return "";
      }
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getBillList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getBillList();
    },
    showMoreInfo(row) {
      this.moreInfoVisible = true;
      this.curRow = row;
    },
    doneInvoice(row) {
      this.curRow = row;
      // 准备开票
      if (row.invoiceState === InvoiceState.pending) {
        MessageBox.confirm("确定要开票吗？", "注意", {
          showCancelButton: true
        }).then(() => {
          const params = {
            id: row.id,
            orderId: row.orderId,
            invoiceState: InvoiceState.doing,
            invoiceRemark: ""
          }
          InvoiceService.modifyOrderInvoiceState(params).then(res => {
            if (!res) return;
            Message.success("已经开票！");
            this.curRow.invoiceState = InvoiceState.doing;
            this.curRow.invoiceStateLabel = InvoiceStateLabel[InvoiceState.doing];
          });
        })
      } else if (row.invoiceState === InvoiceState.doing) {
        // 完成开票
        this.doneInvoiceVisible = true;
      }
    },
    closeDialog() {
      this.doneInvoiceVisible = false;
      this.formObj.remark = "";
      this.$refs.invoiceForm.clearValidate();
    },
    async saveRemark() {
      await this.$refs.invoiceForm.validate();
      // 完成开票
      const params = {
        id: this.curRow.id,
        orderId: this.curRow.orderId,
        invoiceState: InvoiceState.done,
        invoiceRemark: this.formObj.remark
      }
      InvoiceService.modifyOrderInvoiceState(params).then(res => {
        if (!res) return;
        Message.success("完成开票！");
        this.curRow.invoiceState = InvoiceState.done;
        this.curRow.invoiceRemark = this.formObj.remark;
        this.curRow.invoiceStateLabel = InvoiceStateLabel[InvoiceState.done];
        this.doneInvoiceVisible = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.original-bill {
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 20px;
}
.query {
  width: 200px;
  margin-right: 20px;
  vertical-align: middle;
}
.state {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .state-dot {
    width: 5px;
    margin-right: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
.dialog-footer {
  text-align: right;
  padding-top: 10px;
}
</style>